// Same prefixes as the api (utils/phoneNumber.js, OVERSEAS_COUNTRY_CODES): a French
// overseas number filed in the national format with France selected comes out
// as +33, and only its national prefix tells the real calling code.
const OVERSEAS_CALLING_CODES = {
  590: '590', 690: '590', 691: '590',
  596: '596', 696: '596', 697: '596',
  594: '594', 694: '594',
  262: '262', 692: '262', 693: '262', 269: '262', 639: '262',
};
const E164_PATTERN = /^\+[1-9]\d{6,14}$/;

const correctOverseasNumber = (phone) => {
  const match = /^\+33(\d{3})(\d{6})$/.exec(phone);
  const callingCode = match && OVERSEAS_CALLING_CODES[match[1]];
  return callingCode ? `+${callingCode}${match[1]}${match[2]}` : phone;
};

// react-phone-number-input logs an error for any value that is not E.164, and
// HubSpot's number can carry spaces or be missing.
export const toPhoneValue = (raw) => {
  const compact = typeof raw === 'string' ? raw.replace(/\s+/g, '') : '';
  return E164_PATTERN.test(compact) ? correctOverseasNumber(compact) : undefined;
};
